import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Stimulus-Use 0.50.0-1
*/
import { Controller } from '@hotwired/stimulus';
import hotkeys from 'hotkeys-js';

var method = function method(controller, methodName) {
  var method = controller[methodName];

  if (typeof method == 'function') {
    return method;
  } else {
    return function () {};
  }
};

var composeEventName = function composeEventName(name, controller, eventPrefix) {
  var composedName = name;

  if (eventPrefix === true) {
    composedName = "".concat(controller.identifier, ":").concat(name);
  } else if (typeof eventPrefix === 'string') {
    composedName = "".concat(eventPrefix, ":").concat(name);
  }

  return composedName;
};

var extendedEvent = function extendedEvent(type, event, detail) {
  var _ref = event || {
    bubbles: true,
    cancelable: true,
    composed: true
  },
      bubbles = _ref.bubbles,
      cancelable = _ref.cancelable,
      composed = _ref.composed;

  if (event) {
    Object.assign(detail, {
      originalEvent: event
    });
  }

  var customEvent = new CustomEvent(type, {
    bubbles: bubbles,
    cancelable: cancelable,
    composed: composed,
    detail: detail
  });
  return customEvent;
};

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;
  var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horInView;
}

function camelize(value) {
  return value.replace(/(?:[_-])([a-z0-9])/g, function (_, char) {
    return char.toUpperCase();
  });
}

var defaultOptions$7 = {
  dispatchEvent: true,
  eventPrefix: true
};

var useIntersection = function useIntersection(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign = Object.assign({}, defaultOptions$7, options),
      dispatchEvent = _Object$assign.dispatchEvent,
      eventPrefix = _Object$assign.eventPrefix;

  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;

  var callback = function callback(entries) {
    var _entries = _slicedToArray(entries, 1),
        entry = _entries[0];

    if (entry.isIntersecting) {
      dispatchAppear(entry);
    } else if (controller.isVisible) {
      dispatchDisappear(entry);
    }
  };

  var dispatchAppear = function dispatchAppear(entry) {
    controller.isVisible = true;
    method(controller, 'appear').call(controller, entry);

    if (dispatchEvent) {
      var eventName = composeEventName('appear', controller, eventPrefix);
      var appearEvent = extendedEvent(eventName, null, {
        controller: controller,
        entry: entry
      });
      targetElement.dispatchEvent(appearEvent);
    }
  };

  var dispatchDisappear = function dispatchDisappear(entry) {
    controller.isVisible = false;
    method(controller, 'disappear').call(controller, entry);

    if (dispatchEvent) {
      var eventName = composeEventName('disappear', controller, eventPrefix);
      var disappearEvent = extendedEvent(eventName, null, {
        controller: controller,
        entry: entry
      });
      targetElement.dispatchEvent(disappearEvent);
    }
  };

  var controllerDisconnect = controller.disconnect.bind(controller);
  var observer = new IntersectionObserver(callback, options);

  var observe = function observe() {
    observer.observe(targetElement);
  };

  var unobserve = function unobserve() {
    observer.unobserve(targetElement);
  };

  Object.assign(controller, {
    isVisible: false,
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};

var IntersectionComposableController = /*#__PURE__*/function (_Controller) {
  _inherits(IntersectionComposableController, _Controller);

  var _super = _createSuper(IntersectionComposableController);

  function IntersectionComposableController() {
    var _this;

    _classCallCheck(this, IntersectionComposableController);

    _this = _super.apply(this, arguments);
    _this.isVisible = false;
    return _this;
  }

  return IntersectionComposableController;
}(Controller);

var IntersectionController = /*#__PURE__*/function (_IntersectionComposab) {
  _inherits(IntersectionController, _IntersectionComposab);

  var _super2 = _createSuper(IntersectionController);

  function IntersectionController(context) {
    var _this2;

    _classCallCheck(this, IntersectionController);

    _this2 = _super2.call(this, context);
    requestAnimationFrame(function () {
      var _useIntersection = useIntersection(_assertThisInitialized(_this2), _this2.options),
          _useIntersection2 = _slicedToArray(_useIntersection, 2),
          observe = _useIntersection2[0],
          unobserve = _useIntersection2[1];

      Object.assign(_assertThisInitialized(_this2), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this2;
  }

  return IntersectionController;
}(IntersectionComposableController);

var useLazyLoad = function useLazyLoad(controller, options) {
  var callback = function callback(entries) {
    var _entries2 = _slicedToArray(entries, 1),
        entry = _entries2[0];

    if (entry.isIntersecting && !controller.isLoaded) {
      handleAppear();
    }
  };

  var handleAppear = function handleAppear(entry) {
    var src = controller.data.get('src');
    if (!src) return;
    var imageElement = controller.element;
    controller.isLoading = true;
    method(controller, 'loading').call(controller, src);

    imageElement.onload = function () {
      handleLoaded(src);
    };

    imageElement.src = src;
  };

  var handleLoaded = function handleLoaded(src) {
    controller.isLoading = false;
    controller.isLoaded = true;
    method(controller, 'loaded').call(controller, src);
  };

  var controllerDisconnect = controller.disconnect.bind(controller);
  var observer = new IntersectionObserver(callback, options);

  var observe = function observe() {
    observer.observe(controller.element);
  };

  var unobserve = function unobserve() {
    observer.unobserve(controller.element);
  };

  Object.assign(controller, {
    isVisible: false,
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};

var LazyLoadComposableController = /*#__PURE__*/function (_Controller2) {
  _inherits(LazyLoadComposableController, _Controller2);

  var _super3 = _createSuper(LazyLoadComposableController);

  function LazyLoadComposableController() {
    var _this3;

    _classCallCheck(this, LazyLoadComposableController);

    _this3 = _super3.apply(this, arguments);
    _this3.isLoading = false;
    _this3.isLoaded = false;
    return _this3;
  }

  return LazyLoadComposableController;
}(Controller);

var LazyLoadController = /*#__PURE__*/function (_LazyLoadComposableCo) {
  _inherits(LazyLoadController, _LazyLoadComposableCo);

  var _super4 = _createSuper(LazyLoadController);

  function LazyLoadController(context) {
    var _this4;

    _classCallCheck(this, LazyLoadController);

    _this4 = _super4.call(this, context);
    _this4.options = {
      rootMargin: '10%'
    };
    requestAnimationFrame(function () {
      var _useLazyLoad = useLazyLoad(_assertThisInitialized(_this4), _this4.options),
          _useLazyLoad2 = _slicedToArray(_useLazyLoad, 2),
          observe = _useLazyLoad2[0],
          unobserve = _useLazyLoad2[1];

      Object.assign(_assertThisInitialized(_this4), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this4;
  }

  return LazyLoadController;
}(LazyLoadComposableController);

var defaultOptions$6 = {
  dispatchEvent: true,
  eventPrefix: true
};

var useResize = function useResize(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign2 = Object.assign({}, defaultOptions$6, options),
      dispatchEvent = _Object$assign2.dispatchEvent,
      eventPrefix = _Object$assign2.eventPrefix;

  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;

  var callback = function callback(entries) {
    var _entries3 = _slicedToArray(entries, 1),
        entry = _entries3[0];

    method(controller, 'resize').call(controller, entry.contentRect);

    if (dispatchEvent) {
      var eventName = composeEventName('resize', controller, eventPrefix);
      var appearEvent = extendedEvent(eventName, null, {
        controller: controller,
        entry: entry
      });
      targetElement.dispatchEvent(appearEvent);
    }
  };

  var controllerDisconnect = controller.disconnect.bind(controller);
  var observer = new ResizeObserver(callback);

  var observe = function observe() {
    observer.observe(targetElement);
  };

  var unobserve = function unobserve() {
    observer.unobserve(targetElement);
  };

  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};

var ResizeComposableController = /*#__PURE__*/function (_Controller3) {
  _inherits(ResizeComposableController, _Controller3);

  var _super5 = _createSuper(ResizeComposableController);

  function ResizeComposableController() {
    _classCallCheck(this, ResizeComposableController);

    return _super5.apply(this, arguments);
  }

  return ResizeComposableController;
}(Controller);

var ResizeController = /*#__PURE__*/function (_ResizeComposableCont) {
  _inherits(ResizeController, _ResizeComposableCont);

  var _super6 = _createSuper(ResizeController);

  function ResizeController(context) {
    var _this5;

    _classCallCheck(this, ResizeController);

    _this5 = _super6.call(this, context);
    requestAnimationFrame(function () {
      var _useResize = useResize(_assertThisInitialized(_this5), _this5.options),
          _useResize2 = _slicedToArray(_useResize, 2),
          observe = _useResize2[0],
          unobserve = _useResize2[1];

      Object.assign(_assertThisInitialized(_this5), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this5;
  }

  return ResizeController;
}(ResizeComposableController);

var defaultOptions$5 = {
  events: ['click', 'touchend'],
  onlyVisible: true,
  dispatchEvent: true,
  eventPrefix: true
};

var useClickOutside = function useClickOutside(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign3 = Object.assign({}, defaultOptions$5, options),
      onlyVisible = _Object$assign3.onlyVisible,
      dispatchEvent = _Object$assign3.dispatchEvent,
      events = _Object$assign3.events,
      eventPrefix = _Object$assign3.eventPrefix;

  var onEvent = function onEvent(event) {
    var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;

    if (targetElement.contains(event.target) || !isElementInViewport(targetElement) && onlyVisible) {
      return;
    }

    if (controller.clickOutside) {
      controller.clickOutside(event);
    }

    if (dispatchEvent) {
      var eventName = composeEventName('click:outside', controller, eventPrefix);
      var clickOutsideEvent = extendedEvent(eventName, event, {
        controller: controller
      });
      targetElement.dispatchEvent(clickOutsideEvent);
    }
  };

  var observe = function observe() {
    events === null || events === void 0 ? void 0 : events.forEach(function (event) {
      window.addEventListener(event, onEvent, false);
    });
  };

  var unobserve = function unobserve() {
    events === null || events === void 0 ? void 0 : events.forEach(function (event) {
      window.removeEventListener(event, onEvent, false);
    });
  };

  var controllerDisconnect = controller.disconnect.bind(controller);
  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};

var ClickOutsideComposableController = /*#__PURE__*/function (_Controller4) {
  _inherits(ClickOutsideComposableController, _Controller4);

  var _super7 = _createSuper(ClickOutsideComposableController);

  function ClickOutsideComposableController() {
    _classCallCheck(this, ClickOutsideComposableController);

    return _super7.apply(this, arguments);
  }

  return ClickOutsideComposableController;
}(Controller);

var ClickOutsideController = /*#__PURE__*/function (_ClickOutsideComposab) {
  _inherits(ClickOutsideController, _ClickOutsideComposab);

  var _super8 = _createSuper(ClickOutsideController);

  function ClickOutsideController(context) {
    var _this6;

    _classCallCheck(this, ClickOutsideController);

    _this6 = _super8.call(this, context);
    requestAnimationFrame(function () {
      var _useClickOutside = useClickOutside(_assertThisInitialized(_this6), _this6.options),
          _useClickOutside2 = _slicedToArray(_useClickOutside, 2),
          observe = _useClickOutside2[0],
          unobserve = _useClickOutside2[1];

      Object.assign(_assertThisInitialized(_this6), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this6;
  }

  return ClickOutsideController;
}(ClickOutsideComposableController);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var defaultOptions$4 = {
  debug: false,
  logger: console,
  dispatchEvent: true,
  eventPrefix: true
};

var StimulusUse = function StimulusUse(controller) {
  var _this7 = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, StimulusUse);

  var _a, _b, _c;

  this.log = function (functionName, args) {
    if (!_this7.debug) return;

    _this7.logger.groupCollapsed("%c".concat(_this7.controller.identifier, " %c#").concat(functionName), 'color: #3B82F6', 'color: unset');

    _this7.logger.log(Object.assign({
      controllerId: _this7.controllerId
    }, args));

    _this7.logger.groupEnd();
  };

  this.dispatch = function (eventName) {
    var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_this7.dispatchEvent) {
      var event = details.event,
          eventDetails = __rest(details, ["event"]);

      var customEvent = _this7.extendedEvent(eventName, event || null, eventDetails);

      _this7.targetElement.dispatchEvent(customEvent);

      _this7.log('dispatchEvent', Object.assign({
        eventName: customEvent.type
      }, eventDetails));
    }
  };

  this.call = function (methodName) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = _this7.controller[methodName];

    if (typeof method == 'function') {
      return method.call(_this7.controller, args);
    }
  };

  this.extendedEvent = function (name, event, detail) {
    var _ref2 = event || {
      bubbles: true,
      cancelable: true,
      composed: true
    },
        bubbles = _ref2.bubbles,
        cancelable = _ref2.cancelable,
        composed = _ref2.composed;

    if (event) {
      Object.assign(detail, {
        originalEvent: event
      });
    }

    var customEvent = new CustomEvent(_this7.composeEventName(name), {
      bubbles: bubbles,
      cancelable: cancelable,
      composed: composed,
      detail: detail
    });
    return customEvent;
  };

  this.composeEventName = function (name) {
    var composedName = name;

    if (_this7.eventPrefix === true) {
      composedName = "".concat(_this7.controller.identifier, ":").concat(name);
    } else if (typeof _this7.eventPrefix === 'string') {
      composedName = "".concat(_this7.eventPrefix, ":").concat(name);
    }

    return composedName;
  };

  this.debug = (_b = (_a = options === null || options === void 0 ? void 0 : options.debug) !== null && _a !== void 0 ? _a : controller.application.stimulusUseDebug) !== null && _b !== void 0 ? _b : defaultOptions$4.debug;
  this.logger = (_c = options === null || options === void 0 ? void 0 : options.logger) !== null && _c !== void 0 ? _c : defaultOptions$4.logger;
  this.controller = controller;
  this.controllerId = controller.element.id || controller.element.dataset.id;
  this.targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;

  var _Object$assign4 = Object.assign({}, defaultOptions$4, options),
      dispatchEvent = _Object$assign4.dispatchEvent,
      eventPrefix = _Object$assign4.eventPrefix;

  Object.assign(this, {
    dispatchEvent: dispatchEvent,
    eventPrefix: eventPrefix
  });
  this.controllerInitialize = controller.initialize.bind(controller);
  this.controllerConnect = controller.connect.bind(controller);
  this.controllerDisconnect = controller.disconnect.bind(controller);
};

var defaultOptions$3 = {
  eventPrefix: true,
  bubbles: true,
  cancelable: true
};

var UseDispatch = /*#__PURE__*/function (_StimulusUse) {
  _inherits(UseDispatch, _StimulusUse);

  var _super9 = _createSuper(UseDispatch);

  function UseDispatch(controller) {
    var _this8;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseDispatch);

    var _a, _b, _c, _d;

    _this8 = _super9.call(this, controller, options);

    _this8.dispatch = function (eventName) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _assertThisInitialize = _assertThisInitialized(_this8),
          controller = _assertThisInitialize.controller,
          targetElement = _assertThisInitialize.targetElement,
          eventPrefix = _assertThisInitialize.eventPrefix,
          bubbles = _assertThisInitialize.bubbles,
          cancelable = _assertThisInitialize.cancelable,
          log = _assertThisInitialize.log;

      Object.assign(detail, {
        controller: controller
      });
      var eventNameWithPrefix = composeEventName(eventName, _this8.controller, eventPrefix);
      var event = new CustomEvent(eventNameWithPrefix, {
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      });
      targetElement.dispatchEvent(event);
      log('dispatch', {
        eventName: eventNameWithPrefix,
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      });
      return event;
    };

    _this8.targetElement = (_a = options.element) !== null && _a !== void 0 ? _a : controller.element;
    _this8.eventPrefix = (_b = options.eventPrefix) !== null && _b !== void 0 ? _b : defaultOptions$3.eventPrefix;
    _this8.bubbles = (_c = options.bubbles) !== null && _c !== void 0 ? _c : defaultOptions$3.bubbles;
    _this8.cancelable = (_d = options.cancelable) !== null && _d !== void 0 ? _d : defaultOptions$3.cancelable;

    _this8.enhanceController();

    return _this8;
  }

  _createClass(UseDispatch, [{
    key: "enhanceController",
    value: function enhanceController() {
      Object.assign(this.controller, {
        dispatch: this.dispatch
      });
    }
  }]);

  return UseDispatch;
}(StimulusUse);

var useDispatch = function useDispatch(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new UseDispatch(controller, options);
};

var useApplication = function useApplication(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.defineProperty(controller, 'isPreview', {
    get: function get() {
      return document.documentElement.hasAttribute('data-turbolinks-preview') || document.documentElement.hasAttribute('data-turbo-preview');
    }
  });
  Object.defineProperty(controller, 'isConnected', {
    get: function get() {
      var _this9 = this;

      return !!Array.from(this.context.module.connectedContexts).find(function (c) {
        return c === _this9.context;
      });
    }
  });
  Object.defineProperty(controller, 'csrfToken', {
    get: function get() {
      return this.metaValue('csrf-token');
    }
  });
  useDispatch(controller, options);
  Object.assign(controller, {
    metaValue: function metaValue(name) {
      var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
      return element && element.getAttribute('content');
    }
  });
};

var ApplicationController = /*#__PURE__*/function (_Controller5) {
  _inherits(ApplicationController, _Controller5);

  var _super10 = _createSuper(ApplicationController);

  function ApplicationController(context) {
    var _this10;

    _classCallCheck(this, ApplicationController);

    _this10 = _super10.call(this, context);
    _this10.isPreview = false;
    _this10.isConnected = false;
    _this10.csrfToken = '';
    useApplication(_assertThisInitialized(_this10), _this10.options);
    return _this10;
  }

  return ApplicationController;
}(Controller);

var defaultEvents = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel'];
var oneMinute = 60e3;
var defaultOptions$2 = {
  ms: oneMinute,
  initialState: false,
  events: defaultEvents,
  dispatchEvent: true,
  eventPrefix: true
};

var useIdle = function useIdle(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign5 = Object.assign({}, defaultOptions$2, options),
      ms = _Object$assign5.ms,
      initialState = _Object$assign5.initialState,
      events = _Object$assign5.events,
      dispatchEvent = _Object$assign5.dispatchEvent,
      eventPrefix = _Object$assign5.eventPrefix;

  var isIdle = initialState;
  var timeout = setTimeout(function () {
    isIdle = true;
    dispatchAway();
  }, ms);

  var dispatchAway = function dispatchAway(event) {
    var eventName = composeEventName('away', controller, eventPrefix);
    controller.isIdle = true;
    method(controller, 'away').call(controller, event);

    if (dispatchEvent) {
      var clickOutsideEvent = extendedEvent(eventName, event || null, {
        controller: controller
      });
      controller.element.dispatchEvent(clickOutsideEvent);
    }
  };

  var dispatchBack = function dispatchBack(event) {
    var eventName = composeEventName('back', controller, eventPrefix);
    controller.isIdle = false;
    method(controller, 'back').call(controller, event);

    if (dispatchEvent) {
      var clickOutsideEvent = extendedEvent(eventName, event || null, {
        controller: controller
      });
      controller.element.dispatchEvent(clickOutsideEvent);
    }
  };

  var onEvent = function onEvent(event) {
    if (isIdle) dispatchBack(event);
    isIdle = false;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      isIdle = true;
      dispatchAway(event);
    }, ms);
  };

  var onVisibility = function onVisibility(event) {
    if (!document.hidden) onEvent(event);
  };

  if (isIdle) {
    dispatchAway();
  } else {
    dispatchBack();
  }

  var controllerDisconnect = controller.disconnect.bind(controller);

  var observe = function observe() {
    events.forEach(function (event) {
      window.addEventListener(event, onEvent);
    });
    document.addEventListener('visibilitychange', onVisibility);
  };

  var unobserve = function unobserve() {
    events.forEach(function (event) {
      window.removeEventListener(event, onEvent);
    });
    document.removeEventListener('visibilitychange', onVisibility);
  };

  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};

var IdleComposableController = /*#__PURE__*/function (_Controller6) {
  _inherits(IdleComposableController, _Controller6);

  var _super11 = _createSuper(IdleComposableController);

  function IdleComposableController() {
    var _this11;

    _classCallCheck(this, IdleComposableController);

    _this11 = _super11.apply(this, arguments);
    _this11.isIdle = false;
    return _this11;
  }

  return IdleComposableController;
}(Controller);

var IdleController = /*#__PURE__*/function (_IdleComposableContro) {
  _inherits(IdleController, _IdleComposableContro);

  var _super12 = _createSuper(IdleController);

  function IdleController(context) {
    var _this12;

    _classCallCheck(this, IdleController);

    _this12 = _super12.call(this, context);
    requestAnimationFrame(function () {
      var _useIdle = useIdle(_assertThisInitialized(_this12), _this12.options),
          _useIdle2 = _slicedToArray(_useIdle, 2),
          observe = _useIdle2[0],
          unobserve = _useIdle2[1];

      Object.assign(_assertThisInitialized(_this12), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this12;
  }

  return IdleController;
}(IdleComposableController);

var UseVisibility = /*#__PURE__*/function (_StimulusUse2) {
  _inherits(UseVisibility, _StimulusUse2);

  var _super13 = _createSuper(UseVisibility);

  function UseVisibility(controller) {
    var _this13;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseVisibility);

    _this13 = _super13.call(this, controller, options);

    _this13.observe = function () {
      _this13.controller.isVisible = !document.hidden;
      document.addEventListener('visibilitychange', _this13.handleVisibilityChange);

      _this13.handleVisibilityChange();
    };

    _this13.unobserve = function () {
      document.removeEventListener('visibilitychange', _this13.handleVisibilityChange);
    };

    _this13.becomesInvisible = function (event) {
      _this13.controller.isVisible = false;

      _this13.call('invisible', event);

      _this13.log('invisible', {
        isVisible: false
      });

      _this13.dispatch('invisible', {
        event: event,
        isVisible: false
      });
    };

    _this13.becomesVisible = function (event) {
      _this13.controller.isVisible = true;

      _this13.call('visible', event);

      _this13.log('visible', {
        isVisible: true
      });

      _this13.dispatch('visible', {
        event: event,
        isVisible: true
      });
    };

    _this13.handleVisibilityChange = function (event) {
      if (document.hidden) {
        _this13.becomesInvisible(event);
      } else {
        _this13.becomesVisible(event);
      }
    };

    _this13.controller = controller;

    _this13.enhanceController();

    _this13.observe();

    return _this13;
  }

  _createClass(UseVisibility, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this14 = this;

      var controllerDisconnect = this.controllerDisconnect;

      var disconnect = function disconnect() {
        _this14.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseVisibility;
}(StimulusUse);

var useVisibility = function useVisibility(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseVisibility(controller, options);
  return [observer.observe, observer.unobserve];
};

var VisibilityComposableController = /*#__PURE__*/function (_Controller7) {
  _inherits(VisibilityComposableController, _Controller7);

  var _super14 = _createSuper(VisibilityComposableController);

  function VisibilityComposableController() {
    var _this15;

    _classCallCheck(this, VisibilityComposableController);

    _this15 = _super14.apply(this, arguments);
    _this15.isVisible = false;
    return _this15;
  }

  return VisibilityComposableController;
}(Controller);

var VisibilityController = /*#__PURE__*/function (_VisibilityComposable) {
  _inherits(VisibilityController, _VisibilityComposable);

  var _super15 = _createSuper(VisibilityController);

  function VisibilityController(context) {
    var _this16;

    _classCallCheck(this, VisibilityController);

    _this16 = _super15.call(this, context);
    requestAnimationFrame(function () {
      var _useVisibility = useVisibility(_assertThisInitialized(_this16), _this16.options),
          _useVisibility2 = _slicedToArray(_useVisibility, 2),
          observe = _useVisibility2[0],
          unobserve = _useVisibility2[1];

      Object.assign(_assertThisInitialized(_this16), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this16;
  }

  return VisibilityController;
}(VisibilityComposableController);

var UseHover = /*#__PURE__*/function (_StimulusUse3) {
  _inherits(UseHover, _StimulusUse3);

  var _super16 = _createSuper(UseHover);

  function UseHover(controller) {
    var _this17;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseHover);

    _this17 = _super16.call(this, controller, options);

    _this17.observe = function () {
      _this17.targetElement.addEventListener('mouseenter', _this17.onEnter);

      _this17.targetElement.addEventListener('mouseleave', _this17.onLeave);
    };

    _this17.unobserve = function () {
      _this17.targetElement.removeEventListener('mouseenter', _this17.onEnter);

      _this17.targetElement.removeEventListener('mouseleave', _this17.onLeave);
    };

    _this17.onEnter = function (event) {
      _this17.call('mouseEnter', event);

      _this17.log('mouseEnter', {
        hover: true
      });

      _this17.dispatch('mouseEnter', {
        hover: false
      });
    };

    _this17.onLeave = function (event) {
      _this17.call('mouseLeave', event);

      _this17.log('mouseLeave', {
        hover: false
      });

      _this17.dispatch('mouseLeave', {
        hover: false
      });
    };

    _this17.controller = controller;

    _this17.enhanceController();

    _this17.observe();

    return _this17;
  }

  _createClass(UseHover, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this18 = this;

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this18.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseHover;
}(StimulusUse);

var useHover = function useHover(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseHover(controller, options);
  return [observer.observe, observer.unobserve];
};

var HoverComposableController = /*#__PURE__*/function (_Controller8) {
  _inherits(HoverComposableController, _Controller8);

  var _super17 = _createSuper(HoverComposableController);

  function HoverComposableController() {
    _classCallCheck(this, HoverComposableController);

    return _super17.apply(this, arguments);
  }

  return HoverComposableController;
}(Controller);

var HoverController = /*#__PURE__*/function (_HoverComposableContr) {
  _inherits(HoverController, _HoverComposableContr);

  var _super18 = _createSuper(HoverController);

  function HoverController(context) {
    var _this19;

    _classCallCheck(this, HoverController);

    _this19 = _super18.call(this, context);
    requestAnimationFrame(function () {
      var _useHover = useHover(_assertThisInitialized(_this19), _this19.options),
          _useHover2 = _slicedToArray(_useHover, 2),
          observe = _useHover2[0],
          unobserve = _useHover2[1];

      Object.assign(_assertThisInitialized(_this19), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this19;
  }

  return HoverController;
}(HoverComposableController);

var UseMutation = /*#__PURE__*/function (_StimulusUse4) {
  _inherits(UseMutation, _StimulusUse4);

  var _super19 = _createSuper(UseMutation);

  function UseMutation(controller) {
    var _this20;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseMutation);

    _this20 = _super19.call(this, controller, options);

    _this20.observe = function () {
      try {
        _this20.observer.observe(_this20.targetElement, _this20.options);
      } catch (error) {
        _this20.controller.application.handleError(error, 'At a minimum, one of childList, attributes, and/or characterData must be true', {});
      }
    };

    _this20.unobserve = function () {
      _this20.observer.disconnect();
    };

    _this20.mutation = function (entries) {
      _this20.call('mutate', entries);

      _this20.log('mutate', {
        entries: entries
      });

      _this20.dispatch('mutate', {
        entries: entries
      });
    };

    _this20.targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
    _this20.controller = controller;
    _this20.options = options;
    _this20.observer = new MutationObserver(_this20.mutation);

    _this20.enhanceController();

    _this20.observe();

    return _this20;
  }

  _createClass(UseMutation, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this21 = this;

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this21.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseMutation;
}(StimulusUse);

var useMutation = function useMutation(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseMutation(controller, options);
  return [observer.observe, observer.unobserve];
};

var MutationComposableController = /*#__PURE__*/function (_Controller9) {
  _inherits(MutationComposableController, _Controller9);

  var _super20 = _createSuper(MutationComposableController);

  function MutationComposableController() {
    _classCallCheck(this, MutationComposableController);

    return _super20.apply(this, arguments);
  }

  return MutationComposableController;
}(Controller);

var MutationController = /*#__PURE__*/function (_MutationComposableCo) {
  _inherits(MutationController, _MutationComposableCo);

  var _super21 = _createSuper(MutationController);

  function MutationController(context) {
    var _this22;

    _classCallCheck(this, MutationController);

    _this22 = _super21.call(this, context);
    requestAnimationFrame(function () {
      var _useMutation = useMutation(_assertThisInitialized(_this22), _this22.options),
          _useMutation2 = _slicedToArray(_useMutation, 2),
          observe = _useMutation2[0],
          unobserve = _useMutation2[1];

      Object.assign(_assertThisInitialized(_this22), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this22;
  }

  return MutationController;
}(MutationComposableController);

var UseTargetMutation = /*#__PURE__*/function (_StimulusUse5) {
  _inherits(UseTargetMutation, _StimulusUse5);

  var _super22 = _createSuper(UseTargetMutation);

  function UseTargetMutation(controller) {
    var _this23;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseTargetMutation);

    _this23 = _super22.call(this, controller, options);

    _this23.observe = function () {
      _this23.observer.observe(_this23.targetElement, {
        subtree: true,
        characterData: true,
        childList: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: [_this23.targetSelector, _this23.scopedTargetSelector]
      });
    };

    _this23.unobserve = function () {
      _this23.observer.disconnect();
    };

    _this23.mutation = function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        var _loop = function _loop() {
          var mutation = _step.value;

          switch (mutation.type) {
            case 'attributes':
              var newValue = mutation.target.getAttribute(mutation.attributeName);
              var oldValue = mutation.oldValue;

              if (mutation.attributeName === _this23.targetSelector || mutation.attributeName === _this23.scopedTargetSelector) {
                var oldTargets = _this23.targetsUsedByThisController(oldValue);

                var newTargets = _this23.targetsUsedByThisController(newValue);

                var removedTargets = oldTargets.filter(function (target) {
                  return !newTargets.includes(target);
                });
                var addedTargets = newTargets.filter(function (target) {
                  return !oldTargets.includes(target);
                });
                removedTargets.forEach(function (target) {
                  return _this23.targetRemoved(_this23.stripIdentifierPrefix(target), mutation.target, 'attributeChange');
                });
                addedTargets.forEach(function (target) {
                  return _this23.targetAdded(_this23.stripIdentifierPrefix(target), mutation.target, 'attributeChange');
                });
              }

              break;

            case 'characterData':
              var nodule = _this23.findTargetInAncestry(mutation.target);

              if (nodule == null) {
                return {
                  v: void 0
                };
              } else {
                var supportedTargets = _this23.targetsUsedByThisControllerFromNode(nodule);

                supportedTargets.forEach(function (target) {
                  _this23.targetChanged(_this23.stripIdentifierPrefix(target), nodule, 'domMutation');
                });
              }

              break;

            case 'childList':
              var addedNodes = mutation.addedNodes,
                  removedNodes = mutation.removedNodes;
              addedNodes.forEach(function (node) {
                return _this23.processNodeDOMMutation(node, _this23.targetAdded);
              });
              removedNodes.forEach(function (node) {
                return _this23.processNodeDOMMutation(node, _this23.targetRemoved);
              });
              break;
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    _this23.controller = controller;
    _this23.options = options;
    _this23.targetElement = controller.element;
    _this23.identifier = controller.scope.identifier;
    _this23.identifierPrefix = "".concat(_this23.identifier, ".");
    _this23.targetSelector = controller.scope.schema.targetAttribute;
    _this23.scopedTargetSelector = "data-".concat(_this23.identifier, "-target");
    _this23.targets = options.targets || controller.constructor.targets;
    _this23.prefixedTargets = _this23.targets.map(function (target) {
      return "".concat(_this23.identifierPrefix).concat(target);
    });
    _this23.observer = new MutationObserver(_this23.mutation);

    _this23.enhanceController();

    _this23.observe();

    return _this23;
  }

  _createClass(UseTargetMutation, [{
    key: "processNodeDOMMutation",
    value: function processNodeDOMMutation(node, initialChangeModeAssumption) {
      var _this24 = this;

      var nodule = node;
      var change = initialChangeModeAssumption;
      var supportedTargets = [];

      if (nodule.nodeName == '#text' || this.targetsUsedByThisControllerFromNode(nodule).length == 0) {
        change = this.targetChanged;
        nodule = this.findTargetInAncestry(node);
      } else {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }

      if (nodule == null) {
        return;
      } else if (supportedTargets.length == 0) {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }

      supportedTargets.forEach(function (target) {
        change.call(_this24, _this24.stripIdentifierPrefix(target), nodule, 'domMutation');
      });
    }
  }, {
    key: "findTargetInAncestry",
    value: function findTargetInAncestry(node) {
      var nodule = node;
      var supportedTargets = [];

      if (nodule.nodeName != '#text') {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }

      while (nodule.parentNode !== null && nodule.parentNode != this.targetElement && supportedTargets.length == 0) {
        nodule = nodule.parentNode;

        if (nodule.nodeName !== '#text') {
          var _supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);

          if (_supportedTargets.length > 0) {
            return nodule;
          }
        }
      }

      if (nodule.nodeName == '#text') {
        return null;
      }

      if (nodule.parentNode == null) {
        return null;
      }

      if (nodule.parentNode == this.targetElement) {
        if (this.targetsUsedByThisControllerFromNode(nodule).length > 0) {
          return nodule;
        }

        return null;
      }

      return null;
    }
  }, {
    key: "targetAdded",
    value: function targetAdded(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetAdded");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log('targetAdded', {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetRemoved",
    value: function targetRemoved(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetRemoved");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log('targetRemoved', {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetChanged",
    value: function targetChanged(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetChanged");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log('targetChanged', {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetsUsedByThisControllerFromNode",
    value: function targetsUsedByThisControllerFromNode(node) {
      if (node.nodeName == '#text' || node.nodeName == '#comment') {
        return [];
      }

      var nodeElement = node;
      return this.targetsUsedByThisController(nodeElement.getAttribute(this.scopedTargetSelector) || nodeElement.getAttribute(this.targetSelector));
    }
  }, {
    key: "targetsUsedByThisController",
    value: function targetsUsedByThisController(targetStr) {
      targetStr = targetStr || '';
      var targetsToCheck = this.stripIdentifierPrefix(targetStr).split(' ');
      return this.targets.filter(function (n) {
        return targetsToCheck.indexOf(n) !== -1;
      });
    }
  }, {
    key: "stripIdentifierPrefix",
    value: function stripIdentifierPrefix(target) {
      return target.replace(new RegExp(this.identifierPrefix, 'g'), '');
    }
  }, {
    key: "enhanceController",
    value: function enhanceController() {
      var _this25 = this;

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this25.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseTargetMutation;
}(StimulusUse);

var useTargetMutation = function useTargetMutation(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseTargetMutation(controller, options);
  return [observer.observe, observer.unobserve];
};

var TargetMutationComposableController = /*#__PURE__*/function (_Controller10) {
  _inherits(TargetMutationComposableController, _Controller10);

  var _super23 = _createSuper(TargetMutationComposableController);

  function TargetMutationComposableController() {
    _classCallCheck(this, TargetMutationComposableController);

    return _super23.apply(this, arguments);
  }

  return TargetMutationComposableController;
}(Controller);

var TargetMutationController = /*#__PURE__*/function (_TargetMutationCompos) {
  _inherits(TargetMutationController, _TargetMutationCompos);

  var _super24 = _createSuper(TargetMutationController);

  function TargetMutationController(context) {
    var _this26;

    _classCallCheck(this, TargetMutationController);

    _this26 = _super24.call(this, context);
    requestAnimationFrame(function () {
      var _useTargetMutation = useTargetMutation(_assertThisInitialized(_this26), _this26.options),
          _useTargetMutation2 = _slicedToArray(_useTargetMutation, 2),
          observe = _useTargetMutation2[0],
          unobserve = _useTargetMutation2[1];

      Object.assign(_assertThisInitialized(_this26), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this26;
  }

  return TargetMutationController;
}(TargetMutationComposableController);

var useWindowResize = function useWindowResize(controller) {
  var callback = function callback(event) {
    var _window = window,
        innerWidth = _window.innerWidth,
        innerHeight = _window.innerHeight;
    var payload = {
      height: innerHeight || Infinity,
      width: innerWidth || Infinity,
      event: event
    };
    method(controller, 'windowResize').call(controller, payload);
  };

  var controllerDisconnect = controller.disconnect.bind(controller);

  var observe = function observe() {
    window.addEventListener('resize', callback);
    callback();
  };

  var unobserve = function unobserve() {
    window.removeEventListener('resize', callback);
  };

  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};

var WindowResizeComposableController = /*#__PURE__*/function (_Controller11) {
  _inherits(WindowResizeComposableController, _Controller11);

  var _super25 = _createSuper(WindowResizeComposableController);

  function WindowResizeComposableController() {
    _classCallCheck(this, WindowResizeComposableController);

    return _super25.apply(this, arguments);
  }

  return WindowResizeComposableController;
}(Controller);

var WindowResizeController = /*#__PURE__*/function (_WindowResizeComposab) {
  _inherits(WindowResizeController, _WindowResizeComposab);

  var _super26 = _createSuper(WindowResizeController);

  function WindowResizeController(context) {
    var _this27;

    _classCallCheck(this, WindowResizeController);

    _this27 = _super26.call(this, context);
    requestAnimationFrame(function () {
      var _useWindowResize = useWindowResize(_assertThisInitialized(_this27)),
          _useWindowResize2 = _slicedToArray(_useWindowResize, 2),
          observe = _useWindowResize2[0],
          unobserve = _useWindowResize2[1];

      Object.assign(_assertThisInitialized(_this27), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this27;
  }

  return WindowResizeController;
}(WindowResizeComposableController);

var memoize = function memoize(controller, name, value) {
  Object.defineProperty(controller, name, {
    value: value
  });
  return value;
};

var useMemo = function useMemo(controller) {
  var _a;

  (_a = controller.constructor.memos) === null || _a === void 0 ? void 0 : _a.forEach(function (getter) {
    memoize(controller, getter, controller[getter]);
  });
};

var DebounceController = /*#__PURE__*/function (_Controller12) {
  _inherits(DebounceController, _Controller12);

  var _super27 = _createSuper(DebounceController);

  function DebounceController() {
    _classCallCheck(this, DebounceController);

    return _super27.apply(this, arguments);
  }

  return DebounceController;
}(Controller);

DebounceController.debounces = [];
var defaultWait$1 = 200;

var debounce = function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWait$1;
  var timeoutId = null;
  return function () {
    var args = arguments;
    var context = this;

    var callback = function callback() {
      return fn.apply(context, args);
    };

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(callback, wait);
  };
};

var useDebounce = function useDebounce(controller, options) {
  var _a;

  var constructor = controller.constructor;
  (_a = constructor.debounces) === null || _a === void 0 ? void 0 : _a.forEach(function (func) {
    if (typeof func === 'string') {
      controller[func] = debounce(controller[func], options === null || options === void 0 ? void 0 : options.wait);
    }

    if (_typeof(func) === 'object') {
      var name = func.name,
          wait = func.wait;
      if (!name) return;
      controller[name] = debounce(controller[name], wait || (options === null || options === void 0 ? void 0 : options.wait));
    }
  });
};

var ThrottleController = /*#__PURE__*/function (_Controller13) {
  _inherits(ThrottleController, _Controller13);

  var _super28 = _createSuper(ThrottleController);

  function ThrottleController() {
    _classCallCheck(this, ThrottleController);

    return _super28.apply(this, arguments);
  }

  return ThrottleController;
}(Controller);

ThrottleController.throttles = [];
var defaultWait = 200;

function throttle(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWait;
  var inThrottle;
  return function () {
    var args = arguments;
    var context = this;

    if (!inThrottle) {
      inThrottle = true;
      func.apply(context, args);
      setTimeout(function () {
        return inThrottle = false;
      }, wait);
    }
  };
}

var useThrottle = function useThrottle(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a;

  var constructor = controller.constructor;
  (_a = constructor.throttles) === null || _a === void 0 ? void 0 : _a.forEach(function (func) {
    if (typeof func === 'string') {
      controller[func] = throttle(controller[func], options === null || options === void 0 ? void 0 : options.wait);
    }

    if (_typeof(func) === 'object') {
      var name = func.name,
          wait = func.wait;
      if (!name) return;
      controller[name] = throttle(controller[name], wait || (options === null || options === void 0 ? void 0 : options.wait));
    }
  });
};

var defineMetaGetter = function defineMetaGetter(controller, metaName, suffix) {
  var getterName = suffix ? "".concat(camelize(metaName), "Meta") : camelize(metaName);
  Object.defineProperty(controller, getterName, {
    get: function get() {
      return typeCast(metaValue(metaName));
    }
  });
};

function metaValue(name) {
  var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
  return element && element.getAttribute('content');
}

function typeCast(value) {
  try {
    return JSON.parse(value);
  } catch (o_O) {
    return value;
  }
}

var useMeta = function useMeta(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    suffix: true
  };
  var metaNames = controller.constructor.metaNames;
  var suffix = options.suffix;
  metaNames === null || metaNames === void 0 ? void 0 : metaNames.forEach(function (metaName) {
    defineMetaGetter(controller, metaName, suffix);
  });
  Object.defineProperty(controller, 'metas', {
    get: function get() {
      var result = {};
      metaNames === null || metaNames === void 0 ? void 0 : metaNames.forEach(function (metaName) {
        var value = typeCast(metaValue(metaName));

        if (value !== undefined && value !== null) {
          result[camelize(metaName)] = value;
        }
      });
      return result;
    }
  });
};

var alpineNames = {
  enterFromClass: 'enter',
  enterActiveClass: 'enterStart',
  enterToClass: 'enterEnd',
  leaveFromClass: 'leave',
  leaveActiveClass: 'leaveStart',
  leaveToClass: 'leaveEnd'
};
var defaultOptions$1 = {
  transitioned: false,
  hiddenClass: 'hidden',
  preserveOriginalClass: true,
  removeToClasses: true
};

var useTransition = function useTransition(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b, _c;

  var targetName = controller.element.dataset.transitionTarget;
  var targetFromAttribute;

  if (targetName) {
    targetFromAttribute = controller["".concat(targetName, "Target")];
  }

  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || targetFromAttribute || controller.element;
  if (!(targetElement instanceof HTMLElement || targetElement instanceof SVGElement)) return;
  var dataset = targetElement.dataset;
  var leaveAfter = parseInt(dataset.leaveAfter || '') || options.leaveAfter || 0;

  var _Object$assign6 = Object.assign(defaultOptions$1, options),
      transitioned = _Object$assign6.transitioned,
      hiddenClass = _Object$assign6.hiddenClass,
      preserveOriginalClass = _Object$assign6.preserveOriginalClass,
      removeToClasses = _Object$assign6.removeToClasses;

  var controllerEnter = (_a = controller.enter) === null || _a === void 0 ? void 0 : _a.bind(controller);
  var controllerLeave = (_b = controller.leave) === null || _b === void 0 ? void 0 : _b.bind(controller);
  var controllerToggleTransition = (_c = controller.toggleTransition) === null || _c === void 0 ? void 0 : _c.bind(controller);

  function enter(_x) {
    return _enter.apply(this, arguments);
  }

  function _enter() {
    _enter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var enterFromClasses, enterActiveClasses, enterToClasses, leaveToClasses;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!controller.transitioned) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              controller.transitioned = true;
              controllerEnter && controllerEnter(event);
              enterFromClasses = getAttribute('enterFrom', options, dataset);
              enterActiveClasses = getAttribute('enterActive', options, dataset);
              enterToClasses = getAttribute('enterTo', options, dataset);
              leaveToClasses = getAttribute('leaveTo', options, dataset);

              if (!!hiddenClass) {
                targetElement.classList.remove(hiddenClass);
              }

              if (!removeToClasses) {
                removeClasses(targetElement, leaveToClasses);
              }

              _context.next = 12;
              return transition(targetElement, enterFromClasses, enterActiveClasses, enterToClasses, hiddenClass, preserveOriginalClass, removeToClasses);

            case 12:
              if (leaveAfter > 0) {
                setTimeout(function () {
                  leave(event);
                }, leaveAfter);
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _enter.apply(this, arguments);
  }

  function leave(_x2) {
    return _leave.apply(this, arguments);
  }

  function _leave() {
    _leave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
      var leaveFromClasses, leaveActiveClasses, leaveToClasses, enterToClasses;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (controller.transitioned) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              controller.transitioned = false;
              controllerLeave && controllerLeave(event);
              leaveFromClasses = getAttribute('leaveFrom', options, dataset);
              leaveActiveClasses = getAttribute('leaveActive', options, dataset);
              leaveToClasses = getAttribute('leaveTo', options, dataset);
              enterToClasses = getAttribute('enterTo', options, dataset);

              if (!removeToClasses) {
                removeClasses(targetElement, enterToClasses);
              }

              _context2.next = 11;
              return transition(targetElement, leaveFromClasses, leaveActiveClasses, leaveToClasses, hiddenClass, preserveOriginalClass, removeToClasses);

            case 11:
              if (!!hiddenClass) {
                targetElement.classList.add(hiddenClass);
              }

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _leave.apply(this, arguments);
  }

  function toggleTransition(event) {
    controllerToggleTransition && controllerToggleTransition(event);

    if (controller.transitioned) {
      leave();
    } else {
      enter();
    }
  }

  function transition(_x3, _x4, _x5, _x6, _x7, _x8, _x9) {
    return _transition.apply(this, arguments);
  }

  function _transition() {
    _transition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(element, initialClasses, activeClasses, endClasses, hiddenClass, preserveOriginalClass, removeEndClasses) {
      var stashedClasses;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              stashedClasses = [];

              if (preserveOriginalClass) {
                initialClasses.forEach(function (cls) {
                  return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
                });
                activeClasses.forEach(function (cls) {
                  return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
                });
                endClasses.forEach(function (cls) {
                  return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
                });
              }

              addClasses(element, initialClasses);
              removeClasses(element, stashedClasses);
              addClasses(element, activeClasses);
              _context3.next = 7;
              return nextAnimationFrame();

            case 7:
              removeClasses(element, initialClasses);
              addClasses(element, endClasses);
              _context3.next = 11;
              return afterTransition(element);

            case 11:
              removeClasses(element, activeClasses);

              if (removeEndClasses) {
                removeClasses(element, endClasses);
              }

              addClasses(element, stashedClasses);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _transition.apply(this, arguments);
  }

  function initialState() {
    controller.transitioned = transitioned;

    if (transitioned) {
      if (!!hiddenClass) {
        targetElement.classList.remove(hiddenClass);
      }

      enter();
    } else {
      if (!!hiddenClass) {
        targetElement.classList.add(hiddenClass);
      }

      leave();
    }
  }

  function addClasses(element, classes) {
    if (classes.length > 0) {
      var _element$classList;

      (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(classes));
    }
  }

  function removeClasses(element, classes) {
    if (classes.length > 0) {
      var _element$classList2;

      (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(classes));
    }
  }

  initialState();
  Object.assign(controller, {
    enter: enter,
    leave: leave,
    toggleTransition: toggleTransition
  });
  return [enter, leave, toggleTransition];
};

function getAttribute(name, options, dataset) {
  var datasetName = "transition".concat(name[0].toUpperCase()).concat(name.substr(1));
  var datasetAlpineName = alpineNames[name];
  var classes = options[name] || dataset[datasetName] || dataset[datasetAlpineName] || ' ';
  return isEmpty(classes) ? [] : classes.split(' ');
}

function afterTransition(_x10) {
  return _afterTransition.apply(this, arguments);
}

function _afterTransition() {
  _afterTransition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(element) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", new Promise(function (resolve) {
              var duration = Number(getComputedStyle(element).transitionDuration.split(',')[0].replace('s', '')) * 1000;
              setTimeout(function () {
                resolve(duration);
              }, duration);
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _afterTransition.apply(this, arguments);
}

function nextAnimationFrame() {
  return _nextAnimationFrame.apply(this, arguments);
}

function _nextAnimationFrame() {
  _nextAnimationFrame = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve) {
              requestAnimationFrame(function () {
                requestAnimationFrame(resolve);
              });
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _nextAnimationFrame.apply(this, arguments);
}

function isEmpty(str) {
  return str.length === 0 || !str.trim();
}

var TransitionComposableController = /*#__PURE__*/function (_Controller14) {
  _inherits(TransitionComposableController, _Controller14);

  var _super29 = _createSuper(TransitionComposableController);

  function TransitionComposableController() {
    var _this28;

    _classCallCheck(this, TransitionComposableController);

    _this28 = _super29.apply(this, arguments);
    _this28.transitioned = false;
    return _this28;
  }

  return TransitionComposableController;
}(Controller);

var TransitionController = /*#__PURE__*/function (_TransitionComposable) {
  _inherits(TransitionController, _TransitionComposable);

  var _super30 = _createSuper(TransitionController);

  function TransitionController(context) {
    var _this29;

    _classCallCheck(this, TransitionController);

    _this29 = _super30.call(this, context);
    requestAnimationFrame(function () {
      useTransition(_assertThisInitialized(_this29), _this29.options);
    });
    return _this29;
  }

  return TransitionController;
}(TransitionComposableController);

var UseHotkeys = /*#__PURE__*/function (_StimulusUse6) {
  _inherits(UseHotkeys, _StimulusUse6);

  var _super31 = _createSuper(UseHotkeys);

  function UseHotkeys(controller, hotkeysOptions) {
    var _this30;

    _classCallCheck(this, UseHotkeys);

    _this30 = _super31.call(this, controller, hotkeysOptions);

    _this30.bind = function () {
      var _loop2 = function _loop2() {
        var _ref3 = _Object$entries[_i2];
        _ref4 = _slicedToArray(_ref3, 2);
        var hotkey = _ref4[0];
        var definition = _ref4[1];
        var handler = definition.handler.bind(_this30.controller);
        hotkeys(hotkey, definition.options, function (e) {
          return handler(e, e);
        });
      };

      for (var _i2 = 0, _Object$entries = Object.entries(_this30.hotkeysOptions.hotkeys); _i2 < _Object$entries.length; _i2++) {
        var _ref4;

        _loop2();
      }
    };

    _this30.unbind = function () {
      for (var hotkey in _this30.hotkeysOptions.hotkeys) {
        hotkeys.unbind(hotkey);
      }
    };

    _this30.controller = controller;
    _this30.hotkeysOptions = hotkeysOptions;

    _this30.enhanceController();

    _this30.bind();

    return _this30;
  }

  _createClass(UseHotkeys, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this31 = this;

      if (this.hotkeysOptions.filter) {
        hotkeys.filter = this.hotkeysOptions.filter;
      }

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this31.unbind();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseHotkeys;
}(StimulusUse);

var convertSimpleHotkeyDefinition = function convertSimpleHotkeyDefinition(definition) {
  return {
    handler: definition[0],
    options: {
      element: definition[1]
    }
  };
};

var coerceOptions = function coerceOptions(options) {
  if (!options.hotkeys) {
    var _hotkeys = {};
    Object.entries(options).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          hotkey = _ref6[0],
          definition = _ref6[1];

      Object.defineProperty(_hotkeys, hotkey, {
        value: convertSimpleHotkeyDefinition(definition),
        writable: false,
        enumerable: true
      });
    });
    options = {
      hotkeys: _hotkeys
    };
  }

  return options;
};

var useHotkeys = function useHotkeys(controller, options) {
  return new UseHotkeys(controller, coerceOptions(options));
};

var defaultOptions = {
  mediaQueries: {},
  dispatchEvent: true,
  eventPrefix: true,
  debug: false
};

var UseMatchMedia = /*#__PURE__*/function (_StimulusUse7) {
  _inherits(UseMatchMedia, _StimulusUse7);

  var _super32 = _createSuper(UseMatchMedia);

  function UseMatchMedia(controller) {
    var _this32;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseMatchMedia);

    var _a, _b, _c, _d;

    _this32 = _super32.call(this, controller, options);
    _this32.matches = [];

    _this32.callback = function (event) {
      var name = Object.keys(_this32.mediaQueries).find(function (name) {
        return _this32.mediaQueries[name] === event.media;
      });
      if (!name) return;
      var media = event.media,
          matches = event.matches;

      _this32.changed({
        name: name,
        media: media,
        matches: matches,
        event: event
      });
    };

    _this32.changed = function (payload) {
      var name = payload.name;

      if (payload.event) {
        _this32.call(camelize("".concat(name, "_changed")), payload);

        _this32.dispatch("".concat(name, ":changed"), payload);

        _this32.log("media query \"".concat(name, "\" changed"), payload);
      }

      if (payload.matches) {
        _this32.call(camelize("is_".concat(name)), payload);

        _this32.dispatch("is:".concat(name), payload);
      } else {
        _this32.call(camelize("not_".concat(name)), payload);

        _this32.dispatch("not:".concat(name), payload);
      }
    };

    _this32.observe = function () {
      Object.keys(_this32.mediaQueries).forEach(function (name) {
        var media = _this32.mediaQueries[name];
        var match = window.matchMedia(media);
        match.addListener(_this32.callback);

        _this32.matches.push(match);

        _this32.changed({
          name: name,
          media: media,
          matches: match.matches
        });
      });
    };

    _this32.unobserve = function () {
      _this32.matches.forEach(function (match) {
        return match.removeListener(_this32.callback);
      });
    };

    _this32.controller = controller;
    _this32.mediaQueries = (_a = options.mediaQueries) !== null && _a !== void 0 ? _a : defaultOptions.mediaQueries;
    _this32.dispatchEvent = (_b = options.dispatchEvent) !== null && _b !== void 0 ? _b : defaultOptions.dispatchEvent;
    _this32.eventPrefix = (_c = options.eventPrefix) !== null && _c !== void 0 ? _c : defaultOptions.eventPrefix;
    _this32.debug = (_d = options.debug) !== null && _d !== void 0 ? _d : defaultOptions.debug;

    if (!window.matchMedia) {
      console.error('window.matchMedia() is not available');
      return _possibleConstructorReturn(_this32);
    }

    _this32.enhanceController();

    _this32.observe();

    return _this32;
  }

  _createClass(UseMatchMedia, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this33 = this;

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this33.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseMatchMedia;
}(StimulusUse);

var useMatchMedia = function useMatchMedia(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseMatchMedia(controller, options);
  return [observer.observe, observer.unobserve];
};

var UseWindowFocus = /*#__PURE__*/function (_StimulusUse8) {
  _inherits(UseWindowFocus, _StimulusUse8);

  var _super33 = _createSuper(UseWindowFocus);

  function UseWindowFocus(controller) {
    var _this34;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseWindowFocus);

    _this34 = _super33.call(this, controller, options);

    _this34.observe = function () {
      if (document.hasFocus()) {
        _this34.becomesFocused();
      } else {
        console.log('i should be there');

        _this34.becomesUnfocused();
      }

      _this34.interval = setInterval(function () {
        _this34.handleWindowFocusChange();
      }, _this34.intervalDuration);
    };

    _this34.unobserve = function () {
      clearInterval(_this34.interval);
    };

    _this34.becomesUnfocused = function (event) {
      _this34.controller.hasFocus = false;

      _this34.call('unfocus', event);

      _this34.log('unfocus', {
        hasFocus: false
      });

      _this34.dispatch('unfocus', {
        event: event,
        hasFocus: false
      });
    };

    _this34.becomesFocused = function (event) {
      _this34.controller.hasFocus = true;

      _this34.call('focus', event);

      _this34.log('focus', {
        hasFocus: true
      });

      _this34.dispatch('focus', {
        event: event,
        hasFocus: true
      });
    };

    _this34.handleWindowFocusChange = function (event) {
      if (document.hasFocus() && !_this34.controller.hasFocus) {
        _this34.becomesFocused(event);
      } else if (!document.hasFocus() && _this34.controller.hasFocus) {
        _this34.becomesUnfocused(event);
      }
    };

    _this34.controller = controller;
    _this34.intervalDuration = options.interval || 200;

    _this34.enhanceController();

    _this34.observe();

    return _this34;
  }

  _createClass(UseWindowFocus, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this35 = this;

      var controllerDisconnect = this.controllerDisconnect;

      var disconnect = function disconnect() {
        _this35.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseWindowFocus;
}(StimulusUse);

var useWindowFocus = function useWindowFocus(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseWindowFocus(controller, options);
  return [observer.observe, observer.unobserve];
};

var WindowFocusComposableController = /*#__PURE__*/function (_Controller15) {
  _inherits(WindowFocusComposableController, _Controller15);

  var _super34 = _createSuper(WindowFocusComposableController);

  function WindowFocusComposableController() {
    var _this36;

    _classCallCheck(this, WindowFocusComposableController);

    _this36 = _super34.apply(this, arguments);
    _this36.hasFocus = false;
    return _this36;
  }

  return WindowFocusComposableController;
}(Controller);

var WindowFocusController = /*#__PURE__*/function (_WindowFocusComposabl) {
  _inherits(WindowFocusController, _WindowFocusComposabl);

  var _super35 = _createSuper(WindowFocusController);

  function WindowFocusController(context) {
    var _this37;

    _classCallCheck(this, WindowFocusController);

    _this37 = _super35.call(this, context);
    requestAnimationFrame(function () {
      var _useWindowFocus = useWindowFocus(_assertThisInitialized(_this37), _this37.options),
          _useWindowFocus2 = _slicedToArray(_useWindowFocus, 2),
          observe = _useWindowFocus2[0],
          unobserve = _useWindowFocus2[1];

      Object.assign(_assertThisInitialized(_this37), {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this37;
  }

  return WindowFocusController;
}(WindowFocusComposableController);

export { ApplicationController, ClickOutsideController, HoverController, IdleController, IntersectionController, LazyLoadController, MutationController, ResizeController, TargetMutationController, TransitionController, UseHover, UseMutation, UseTargetMutation, UseVisibility, VisibilityController, WindowFocusController, WindowResizeController, useApplication, useClickOutside, useDebounce, useDispatch, useHotkeys, useHover, useIdle, useIntersection, useLazyLoad, useMatchMedia, useMemo, useMeta, useMutation, useResize, useTargetMutation, useThrottle, useTransition, useVisibility, useWindowFocus, useWindowResize };